/* @flow */
import { RECEIVE_FOUNDRY_RESPONSE } from '../actions/foundry_response';
import {get, map} from 'lodash';
import extract from '../utils/extract';
import type { Action } from '../actions/types';
import {
  SHOPPING_CATEGORY_COLLECTIONS,
  SHOPPING_CATEGORY_COLLECTIONS_ID
} from '../constants';

const SHOPPING_NAVIGATION_ITEM_KEYS = ['id', 'name', 'path'];

const shimTopLevelCategories =
  (items: ?Array<any>, activeID: Number): Array<CategoryItem> => {
    const categories = map(items, (item: Object): Object => {
      item.is_active = item.id === activeID ? true : false;

      return item;
    });

    // add hard coded Sale page link to category list
    categories.push({
      id: 'sale_page',
      path: '/en-us/shop?on_sale=1',
      is_active: false,
      name: 'sale'
    });

    return categories;
  };

const shimPageTitle =
    (categoryName: ?string, brandOrRetailerName: ?string): string => {
      let pageTitle = '';

      if (categoryName) {
        pageTitle = categoryName;
      } else if (brandOrRetailerName) {
        pageTitle = brandOrRetailerName;
      }

      return pageTitle;
    };

export default (state: NavigationState = {
  categories: [],
  subcategories: [],
  classes: [],
  breadcrumbs: null
}, action: Action): NavigationState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE:
      const shimmedNavigation = {
        ...extract(
          get(action, 'data.page_data.shopping_navigation', []),
          [
            ['categories', SHOPPING_NAVIGATION_ITEM_KEYS],
            ['subcategories', SHOPPING_NAVIGATION_ITEM_KEYS],
            ['classes', SHOPPING_NAVIGATION_ITEM_KEYS]
          ]
        )
      };

      const pageCategoryID = get(action, 'data.page_data.category_id', null);
      const shimmedTopLevelCategoryID =
        get(action, 'data.page_data.category_type') === SHOPPING_CATEGORY_COLLECTIONS
          ? SHOPPING_CATEGORY_COLLECTIONS_ID
          : pageCategoryID;

      shimmedNavigation.categories =
        shimTopLevelCategories(shimmedNavigation.categories, shimmedTopLevelCategoryID);

      const categoryName = get(action, 'data.page_data.category_name', null);
      const brandOrRetailerName = get(action, 'data.page_data.brand_name', null)
                                  || get(action, 'data.page_data.retailer_name', null);

      shimmedNavigation.pageTitle = shimPageTitle(categoryName, brandOrRetailerName);
      shimmedNavigation.breadcrumbs = get(action, 'data.page_data.breadcrumbs', null);

      return shimmedNavigation;
    default:
      return state;
  }
};

type NavigationState = {
  categories: Array<CategoryItem>,
  subcategories: Array<CategoryItem>,
  classes: Array<CategoryItem>
};

type CategoryItem = {
  id: number | string,
  name: string,
  is_active: boolean,
  path?: string
};
